export const organizationTypes = {
  STONE_MINES: "STONE_MINES",
  STONE_CRUSHER: "STONE_CRUSHER",
  COAL_MINES: "COAL_MINES",
};

export const clientOganizationTypes = {
  STONE_MINES: "STONE_MINES",
  STONE_CRUSHER: "STONE_CRUSHER",
  COAL_MINES: "COAL_MINES",
  CONTRACTOR: "CONTRACTOR",
  CONSTRUCTION_COMPANY: "CONSTRUCTION_COMPANY",
  CUSTOMER: "CUSTOMER",
  SUPPLIER: "SUPPLIER",
  OTHER: "OTHER",
};

export const userRoles = {
  OWNER: "OWNER",
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  OPERATOR: "OPERATOR",
  VIEWER: "VIEWER",
};

export const localStoreConfig = {
  mobileNumber: "mobileNumber",
  secureToken: "secureToken",
  organizationId: "organizationId",
  selectedOrganizationId: "selectedOrganizationId",
  selectedClientMap: "selectedClientMap",
};

export const formModes = {
  create: "create",
  update: "update",
};

export const daysMode = {
  day: 1,
  week: 7,
  month: 30,
};

export const reportXAxisMode = {
  daily: "daily",
  weekly: "weekly",
  monthly: "monthly",
};

export const verificationStatus = {
  PENDING: "PENDING",
  VERIFIED: "VERIFIED",
};
